import type { PayCycleApiRow } from '../../../types/PayCycleTypes';
import api from '../../api';

export async function fetchPayCycles(): Promise<PayCycleApiRow[]> {
  const response = await api.get<{ payCycles?: PayCycleApiRow[] }>('/admin-manager/pay-cycles');
  return Array.isArray(response.data.payCycles) ? response.data.payCycles : [];
}

export async function fetchPayCycleTypes(): Promise<{ type_id: number; name: string }[]> {
  const response = await api.get<{ cycleTypes?: { type_id: number; name: string }[] }>('/admin-manager/pay-cycles/types');
  return Array.isArray(response.data.cycleTypes) ? response.data.cycleTypes : [];
}

export async function setPayCycleDisabled(cycleId: number, disabled: boolean) {
  const response = await api.patch<{ payCycleId: number; is_disabled: boolean }>(
    `/admin-manager/pay-cycles/${cycleId}/disabled`,
    { is_disabled: disabled }
  );
  return response.data;
}

export async function createPayCycle(payload: {
  cycle_name: string;
  start_date: string;
  frequency: string;
  exclude_uif?: boolean;
  exclude_sdl?: boolean;
  prorata_bonus?: boolean;
  exclude_tax_cert?: boolean;
}) {
  const response = await api.post<{
    payCycleId: number;
    name: string;
    typeId: number;
    startDate: Date;
    is_disabled: boolean;
  }>('/admin-manager/pay-cycles', payload);
  return response.data;
}
